import { render, staticRenderFns } from "./RecycleRules.vue?vue&type=template&id=3a9938b6&scoped=true&"
import script from "./RecycleRules.vue?vue&type=script&lang=ts&"
export * from "./RecycleRules.vue?vue&type=script&lang=ts&"
import style0 from "./RecycleRules.vue?vue&type=style&index=0&id=3a9938b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9938b6",
  null
  
)

export default component.exports